import { apiFetch } from '@/lib/api/client';

/**
 * AI 에이전트 위임 토큰 (docs/18_2026-07-31_multi-ai-agent-design.md §5.1).
 *
 * 에이전트(:8000)는 세션 쿠키를 모른다. 프론트가 백엔드에서 **단기(5분)·용도한정 토큰**을 받아
 * `Authorization: Bearer` 로 넘기면, 에이전트는 그 토큰을 되물어 신원을 확인하고 이후 도구 호출에도
 * 같은 토큰을 실어 보낸다. 쿠키를 그대로 넘기면 에이전트가 세션 전권을 갖게 되므로 쓰지 않는다.
 *
 * 이 파일이 `lib/auth` 에 있는 이유: 토큰은 인증 관심사이고, 로그아웃({@link ../auth/session})이
 * 캐시를 비워야 한다. 화면 쪽(`pages/aiagent`)에 두면 코어가 페이지를 임포트하는 역전이 생긴다.
 */

type DelegationTokenResponse = { token: string; expiresIn: number };

/**
 * 만료 30초 전에 미리 버린다 — 스트림이 열린 뒤 만료되는 것보다 시작 전에 새로 받는 편이 낫다.
 * 탭 안에서만 사는 메모리 변수라 새로고침하면 사라진다(그래야 한다).
 */
const EXPIRY_MARGIN_MS = 30_000;

let cached: { token: string; expiresAt: number } | null = null;

export async function delegationToken(): Promise<string> {
  if (cached && cached.expiresAt - EXPIRY_MARGIN_MS > Date.now()) return cached.token;

  const issued = await apiFetch<DelegationTokenResponse>('/v1/auth/delegation-token', { method: 'POST' });
  cached = { token: issued.token, expiresAt: Date.now() + issued.expiresIn * 1000 };
  return issued.token;
}

/**
 * 캐시를 버린다. 로그아웃 때와, 토큰이 거부됐을 때(401) 부른다.
 *
 * 로그아웃에서 이걸 빠뜨리면 **다음 사용자의 첫 대화가 이전 사용자 신원으로 나간다** —
 * TanStack 캐시 밖에 있어 `queryClient.clear()` 로는 지워지지 않는다.
 */
export function clearDelegationToken(): void {
  cached = null;
}
